import  headerComponent from './header.vue'

const  vheader={
  install:function (Vue) {
    Vue.component('v-header',headerComponent)
  }
}

export  default vheader;



// WEBPACK FOOTER //
// ./src/components/header/header.js